<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/budgetAccountList' }">预算科目</el-breadcrumb-item>
                <el-breadcrumb-item>预算科目{{type == '1' ? '编辑' : '新增',}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submitDetailsData('ruleDetailsForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleDetailsForm" :label-position="labelPosition" class="details_temp2023">
                        <el-form-item label="预算对象：" prop="budget_object_rid">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.budget_object_rid"
                                filterable
                                reserve-keyword
                                placeholder="请选择预算对象"
                                size="mini"
                                clearable
                                :disabled="type == 1"
                            >
                                <el-option v-for="item in budgetOptions" :key="item.rid" :label="item.full_name" :value="item.rid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="状态：" prop="status">
                            <el-select filterable v-model="ruleForm.status" placeholder="请选择状态" clearable size="mini">
                                <el-option v-for="item in statusOptions" :key="item.value" :label="item.name" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="部门：" prop="department_rid">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.department_name"
                                filterable
                                reserve-keyword
                                placeholder="请选择部门"
                                size="mini"
                                clearable
                                @change="departmentChange"
                                value-key="rid"
                                :disabled="type == 1"
                            >
                                <el-option
                                    v-for="item in departmentOptions"
                                    :key="item.rid"
                                    :label="item.name + '-' + item.code"
                                    :value="item"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="负责人：" prop="principal_rid">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.principal_rid"
                                filterable
                                reserve-keyword
                                placeholder="请选择负责人"
                                size="mini"
                                clearable
                            >
                                <el-option v-for="item in principalOptions" :key="item.rid" :label="item.name" :value="item.rid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="辅助类型：" prop="assistance">
                            <el-select filterable v-model="ruleForm.assistance" placeholder="请选择辅助类型" clearable size="mini" :disabled="type == 1">
                                <el-option v-for="item in assistanceOptions" :key="item.value" :label="item.name" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="ruleForm.assistance == 3" label="合作往来类型：" prop="deal_type">
                            <vDropdown
                                model_key="deal_type"
                                :is_disable="type == 1"
                                model_name="请选择合作往来类型"
                                request_uri="partnerCurrentType"
                                :model_value_default="ruleForm.deal_type"
                                :request_params="{ type: 1 }"
                                select_value="value"
                                @onDropChange="onDropChange"
                                ref="deal_type_ref"
                            ></vDropdown>
                        </el-form-item>
                        <el-form-item label="预算科目类型：" prop="type">
                            <el-select filterable v-model="ruleForm.type" placeholder="请选择预算科目类型" clearable size="mini">
                                <el-option v-for="item in typeOptions" :key="item.value" :label="item.name" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="会计属性：" prop="accounting_attribute" size="mini">
                            <el-select filterable v-model="ruleForm.accounting_attribute" placeholder="请选择预算科目类型" clearable>
                                <el-option v-for="item in attributeOptions" :key="item.value" :label="item.name" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注：" prop="remark">
                            <el-input v-model="ruleForm.remark" size="mini" placeholder="请输入备注" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="创建人：" prop="created_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.created_by ? ruleForm.created_by : '' }} 
                            </div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.updated_by ? ruleForm.updated_by : '' }} 
                            </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    name: 'budgetAccountEdit',
    data() {
        return {
            rid: '',
            title: '', //新增或编辑
            type: '', //1  编辑 2 新增
            activeNames: ['1'],
            labelPosition: 'right',
            typeOptions: [],
            btnLoading: false,
            attributeOptions: [],
            assistanceOptions: [],
            departmentOptions: [],
            budgetOptions: [],
            //基本信息内表单验证
            ruleForm: {
                code: '',
                name: '',
                label: '',
                type: '',
                accounting_attribute: '',
                assistance: '',
                remark: '',
                principal_rid: '',
                status: 1,
                department_rid: '',
                deal_type: 0
            },
            principalLoading: false,
            principalOptions: [],
            states: [],
            statusOptions: [
                {
                    name: '启用',
                    value: 1
                },
                {
                    name: '禁用',
                    value: 2
                }
            ],
            budget_object_rid: '',
            rules: {
                assistance: [{ required: true, message: '请选择辅助类型', trigger: 'blur' }],
                principal_rid: [{ required: true, message: '请选择负责人', trigger: 'blur' }],
                status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
                department_rid: [{ required: true, message: '请选择部门', trigger: 'blur' }],
                budget_object_rid: [{ required: true, message: '请选择预算对象', trigger: 'blur' }],
                deal_type: [{ required: true, message: '请选择合作往来类型', trigger: 'blur' }]
            },
            pathName: '',
            other_id: ''
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
        this.pathName = this.$route.query.pathName;
        this.other_id = this.$route.query.budget_rid;
    },
    mounted() {
        if (this.type == 1 || this.type == 5) {
            this.$nextTick(() => {
                this.getDetails(); //获取详情
            });
        } else {
            this.ruleForm = {
                type: '',
                accounting_attribute: '',
                assistance: '',
                remark: '',
                principal_rid: '',
                status: 1,
                budget_object_rid: this.$route.query.budget_rid ? this.$route.query.budget_rid : '',
                department_rid: '', // 部门 部门下拉（必填）
                deal_type: 0
            };
        }
        this.getType();
        this.getAttribute();
        this.getAssistance();
        this.getBudget();
        this.getPrincipal();
        this.remoteDepartment();
    },
    methods: {
        onDropChange(key, value) {
            this.ruleForm[key] = value;
        },
        //部门下来获取负责人id 自动选中
        departmentChange(val) {
            this.ruleForm.department_rid = val.rid;
            this.ruleForm.principal_rid = val.principal_rid;
        },
        //获取预算对象
        getBudget() {
            let params = {};
            this.$api
                .dropdownBudgetObject(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.budgetOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //获取类型下拉
        getType() {
            let params = {};
            this.$api
                .budgetSubjectType(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.typeOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //部门下拉方法
        remoteDepartment() {
            let params = {};
            this.$api
                .budgetDepartment(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.departmentOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //获取会计属性下拉
        getAttribute() {
            let params = {};
            this.$api
                .budgetSubjectAccountingAttribute(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.attributeOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //获取辅助下拉
        getAssistance() {
            let params = {};
            this.$api
                .budgetSubjectAssistance(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.assistanceOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //获取用户下拉
        getPrincipal() {
            let params = {};
            this.$api
                .dropdownPerson(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.principalOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/budgetAccountList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .budgetSubjectDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.ruleForm = res.data;
                        this.ruleForm.accounting_attribute = Number(this.ruleForm.accounting_attribute);
                        if (this.ruleForm.accounting_attribute == 0) {
                            this.ruleForm.accounting_attribute = '';
                        }
                        if (this.ruleForm.type == 0) {
                            this.ruleForm.type = '';
                        }
                    }
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submitDetailsData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交修改
        submitEditData() {
            let params = {
                type: this.ruleForm.type,
                accounting_attribute: this.ruleForm.accounting_attribute,
                assistance: this.ruleForm.assistance,
                remark: this.ruleForm.remark,
                principal_rid: this.ruleForm.principal_rid,
                budget_object_rid: this.ruleForm.budget_object_rid,
                status: this.ruleForm.status,
                department_rid: this.ruleForm.department_rid,
                deal_type: this.ruleForm.deal_type,
                rid: this.rid
            };
            this.$api
                .budgetSubjectUpdate(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },
        //提交新增
        submitAddData() {
            let params = {
                type: this.ruleForm.type,
                accounting_attribute: this.ruleForm.accounting_attribute,
                assistance: this.ruleForm.assistance,
                remark: this.ruleForm.remark,
                principal_rid: this.ruleForm.principal_rid,
                budget_object_rid: this.ruleForm.budget_object_rid,
                status: this.ruleForm.status,
                department_rid: this.ruleForm.department_rid,
                deal_type: this.ruleForm.deal_type
            };
            this.$api
                .budgetSubjectTnsert(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>